function LongText({ className, text }) {
  return <p className={`${className} whitespace-pre-line`}>{text}</p>;
}

export default LongText;
